import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export const STATUS_META = {
  created: { label: "New file · with operator", color: "bg-slate-100 text-slate-700 ring-slate-200", dot: "bg-slate-400" },
  forwarded_to_manager: { label: "Sent to manager", color: "bg-orange-50 text-orange-700 ring-orange-200", dot: "bg-orange-500" },
  with_manager: { label: "With manager", color: "bg-blue-50 text-blue-700 ring-blue-200", dot: "bg-blue-500" },
  forwarded_to_field: { label: "Sent to field officer", color: "bg-orange-50 text-orange-700 ring-orange-200", dot: "bg-orange-500" },
  with_field_officer: { label: "With field officer", color: "bg-indigo-50 text-indigo-700 ring-indigo-200", dot: "bg-indigo-500" },
  submitted_to_discom: { label: "At Discom · awaiting indent", color: "bg-sky-50 text-sky-700 ring-sky-200", dot: "bg-sky-500" },
  indent_generated: { label: "Indent ready", color: "bg-purple-50 text-purple-700 ring-purple-200", dot: "bg-purple-500" },
  meter_installed: { label: "Meter installed", color: "bg-amber-50 text-amber-800 ring-amber-200", dot: "bg-amber-500" },
  meter_configured: { label: "Meter configured", color: "bg-cyan-50 text-cyan-700 ring-cyan-200", dot: "bg-cyan-500" },
  completed: { label: "Solar active", color: "bg-emerald-50 text-emerald-700 ring-emerald-200", dot: "bg-emerald-500" },
  rejected: { label: "Rejected by Discom", color: "bg-rose-50 text-rose-700 ring-rose-200", dot: "bg-rose-500" },
  resolved: { label: "Fixed · resubmit to Discom", color: "bg-teal-50 text-teal-700 ring-teal-200", dot: "bg-teal-500" },
};

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  manager: "Manager",
  operator: "Operator",
  field_officer: "Field Officer",
  technician: "Installation Technician",
  warehouse: "Warehouse & Dispatch",
};

export const formatDateTime = (iso) => {
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  let h = d.getHours();
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(h)}:${pad(d.getMinutes())} ${ampm}`;
};

export const formatDate = (iso) => {
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};
